import { useLingui } from "@lingui/react/macro";
import InputField from "@medoma/components/InputField/InputField";
import { useFormContext } from "react-hook-form";

const NUMBER_OF_CHARACTERS_ALLOWED_IN_TITLE = 35;

export type ITitleInputFields = {
  title: string;
};

export const TitleInput = ({ suggestions }: { suggestions?: string[] }) => {
  const { t } = useLingui();
  const {
    formState: { errors },
    register,
    trigger,
    clearErrors,
  } = useFormContext<ITitleInputFields>();

  return (
    <InputField
      label={t`Aktivitetstitel`}
      showOptionalLabel={false}
      errorMessage={errors.title?.message}
      suggestions={suggestions}
      {...register(`title`, {
        required: {
          value: true,
          message: t`Aktiviteten behöver en titel`,
        },
        maxLength: {
          value: NUMBER_OF_CHARACTERS_ALLOWED_IN_TITLE,
          message: t`Namnet får max vara ${NUMBER_OF_CHARACTERS_ALLOWED_IN_TITLE} tecken. Lägg ytterligare text i beskrivningen.`,
        },
        onChange: (e) => {
          // User feedback onChange
          if (e?.currentTarget?.value?.length >= 1) {
            void trigger("title");
          } else {
            // ... but don't show annoying errors at this point if the field is empty.
            clearErrors("title");
          }
        },
      })}
    />
  );
};
